import type {
  IIsMassActionRunningInjectedProps,
  IMassActionSelectInjectedProps
} from '@/types/components/mailbox-shared/mass-actions/shared';
import type { InjectionKey } from 'vue';
import type { EventBusKey } from '@vueuse/core';
import type {
  IMailboxMassActionAllResultsBaseRequest,
  IMailboxMassActionBaseRequest,
  IMassActionBaseRequest,
  IMassActionRequest,
  IMassActionRequestWithReset,
  ISearchAllResultsMassActionBaseRequest
} from '@/types/services/massAction.service';

// export const MASS_ACTION_CONTEXT_INJECT_KEY = Symbol(
//   'MASS_ACTION_CONTEXT_INJECT_KEY'
// ) as InjectionKey<Readonly<IMassActionContextInjectedProps>>;
export const MASS_ACTION_RUNNING_INJECT_KEY = Symbol(
  'MASS_ACTION_RUNNING_INJECT_KEY'
) as InjectionKey<Readonly<IIsMassActionRunningInjectedProps>>;

export const MASS_ACTION_SELECT_INJECT_KEY = Symbol(
  'MASS_ACTION_SELECT_INJECT_KEY'
) as InjectionKey<Readonly<IMassActionSelectInjectedProps>>;

export const MASS_ACTION_PRE_QUEUE_EVENT: EventBusKey<IMassActionRequest> = Symbol(
  'MASS_ACTION_PRE_QUEUE_EVENT'
);
export const MASS_ACTION_POST_QUEUE_EVENT: EventBusKey<IMassActionRequestWithReset> = Symbol(
  'MASS_ACTION_POST_QUEUE_EVENT'
);
export const MASS_ACTION_FAILED_EVENT: EventBusKey<IMassActionRequest> = Symbol(
  'MASS_ACTION_FAILED_EVENT'
);

export const isISearchAllResultsSelection = (
  data: IMassActionBaseRequest
): data is ISearchAllResultsMassActionBaseRequest => {
  return (
    typeof data === 'object' &&
    'context' in data &&
    data.context === 'searchAll' &&
    'search' in data &&
    typeof data.search === 'string'
  );
};

export const isIMailboxAllResultsSelection = (
  data: IMassActionBaseRequest
): data is IMailboxMassActionAllResultsBaseRequest => {
  return data.context === 'mailbox' && data.messages.some((msg) => msg.messageId === '*');
};

export const isIMailboxListSelection = (
  data: IMassActionBaseRequest
): data is IMailboxMassActionBaseRequest => {
  return data.context === 'mailbox' && data.messages.some((msg) => msg.messageId !== '*');
};
